// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import HafaSamband from '../../components/HafaSamband/HafaSamband';

const Contact: React.FC = () => {
    return (
        <Entrypoint>
            <HafaSamband />
        </Entrypoint>
    );
}

export default Contact;